import { ReactNode } from 'react';
import moment from 'moment';
import BgNsDatepicker from '@britishgasenergy/react-nucleus/dist/nuc-components/NsDatepicker';

import { NsInputterValidations } from 'components/common/ns-inputter/NsInputterValidations';
import {
  MINIMUM_REQUIRED_AGE,
  MAXIMUM_REQUIRED_AGE,
  DATE_FORMAT
} from 'config/app-config';
import NsInputterEvent from 'components/common/ns-inputter/NsInputterEvent';

type Year = `${number}${number}${number}${number}`;
type Month =
  | '01'
  | '02'
  | '03'
  | '04'
  | '05'
  | '06'
  | '07'
  | '08'
  | '09'
  | '10'
  | '11'
  | '12';
type Day =
  | '01'
  | '02'
  | '03'
  | '04'
  | '05'
  | '06'
  | '07'
  | '08'
  | '09'
  | '10'
  | '11'
  | '12'
  | '13'
  | '14'
  | '15'
  | '16'
  | '17'
  | '18'
  | '19'
  | '20'
  | '21'
  | '22'
  | '23'
  | '24'
  | '25'
  | '26'
  | '27'
  | '28'
  | '29'
  | '30'
  | '31';
// Custom type for date strings in the required format
export type DateString = string & {
  __dateStringBrand: `${Year}-${Month}-${Day}`;
};

const isValidDateString = (date: string): date is DateString => {
  return moment(date, DATE_FORMAT, true).isValid();
};

type NsDatepickerProps = {
  min?: DateString;
  max?: DateString;
  value?: DateString;
  isBirthDate?: boolean;
  label?: string;
  name?: string;
  onChange?: (event: NsInputterEvent) => void;
  validation?: string[];
  tipDetails?: ReactNode | ReactNode[];
  autocomplete?: string;
  helper?: string;
  type?: 'default' | 'mask';
};

export const NsDatepicker = ({
  max,
  min,
  name = 'date',
  type = 'default',
  validation = [NsInputterValidations.isRequired],
  value = '' as DateString,
  tipDetails,
  autocomplete = 'on',
  helper,
  label = 'Date',
  isBirthDate = false,
  onChange = () => {}
}: NsDatepickerProps) => {
  // Validate value date props
  if (value) {
    const error = !isValidDateString(value);
    if (error) {
      console.error('Invalid value date prop: ', value);
    }
  }

  // restrict dates of birth to 'mask' type as per nucleus docs
  const datepickerType = isBirthDate ? 'mask' : type;
  const maxBirthDate = moment()
    .subtract(MINIMUM_REQUIRED_AGE, 'y')
    .format(DATE_FORMAT);
  const minBirthDate = moment()
    .subtract(MAXIMUM_REQUIRED_AGE, 'y')
    .format(DATE_FORMAT);
  const minDate = isBirthDate ? minBirthDate : min;
  const maxDate = isBirthDate ? maxBirthDate : max;

  const changeHandler = (nucleusCustomEvent) => {
    const event = new NsInputterEvent(nucleusCustomEvent);

    onChange(event);
  };

  return (
    <BgNsDatepicker
      label={label}
      name={name}
      value={value || ''}
      min={minDate}
      max={maxDate}
      type={datepickerType}
      validation={validation}
      autocomplete={autocomplete}
      helper={helper}
      onChange={changeHandler}
    >
      {tipDetails && <div slot="tip-details">{tipDetails}</div>}
    </BgNsDatepicker>
  );
};
